<template>
    <div class="card">
        <!-- <h5>All Existing Appliances</h5> -->
        <DataTable
            :totalRecords="totalRecords"
            :loading="loading"
            v-model:first="offset"
            :rows="numberOfRows"
            :lazy="true"
            :paginator="true"
            :multiSortMeta="preSort" sortMode="multiple"  @page="onPage($event)" :value="stations" responsiveLayout="scroll"
            :rowsPerPageOptions="[5, 10, 20, 50, 100]"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" >
<!--            <template #header>-->
<!--                <div class="flex justify-content-end">-->
<!--                    <span class="p-input-icon-left">-->
<!--                        <i class="pi pi-search" />-->
<!--                        <InputText v-model="filters['name'].value" placeholder="Keyword Search" />-->
<!--                    </span>-->
<!--                </div>-->
<!--            </template>-->
            <template #empty>No Station Available</template>
            <Column field="id" header="ID" sortable />
            <Column field="name" header="Station"  />
            <Column field="actions" header="ACTIONS" style="min-width: 8rem">
                <template #body="slotProps">
                    <Button v-if="authStore.hasPermission(UserPermission.WRITE_STATION)" icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editChecklist(slotProps.data)" />
                    <Button v-if="authStore.hasPermission(UserPermission.DELETE_STATION)" icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="confirmRequest(slotProps.data, stationStore.deleteStation)" />
                </template>
            </Column>
        </DataTable>
    </div>

    <!-- Checklist edit form -->
    <station-form v-if="editDialogForm" @hide-dialog="editDialogForm = false" />
</template>

<script setup>
import StationForm from './StationForm.vue';
import { storeToRefs } from 'pinia';
import { ref, onMounted, computed } from 'vue';
import { authStore, stationStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';
import { useConfirmRemove } from '../../../../../composables/ConfirmComposable';

import {
    buildPagination,
    getOrder,
    getPage,
    getPerPage,
    setPage,
    setPerPage,
} from '@/composables/PaginationComposable';

const editDialogForm = ref(false);

const { stations, loading, params, totalRecords } = storeToRefs(stationStore);
const { confirmRequest } = useConfirmRemove();

const tableListCode = 'stationList'

onMounted(() => {
    buildPagination(tableListCode, 0, 10, [{field: "created_at", order: -1}])
    loadStations();
});


const offset = computed(() => {
    return getPage(tableListCode) * getPerPage(tableListCode)
})

const preSort = computed(() => {
    return getOrder(tableListCode)
})

const numberOfRows = computed(() => {
    return getPerPage(tableListCode)
})


const onPage = (event) => {
    params.value = event;
    setPage(tableListCode, event.page)
    setPerPage(tableListCode, event.rows)
    // onSort(event);
    loadStations();
};


const loadStations = async () => {
    await stationStore.fetchAllStations(tableListCode)
};

const editChecklist = (checklist) => {
    stationStore.loadStationBody(checklist);
    editDialogForm.value = true;
};



</script>

